import React from "react";
import { useHistory } from "react-router-dom";
import { thousandFormat } from "../../actions/utiles";

function UnpaidHistoryItem({ history, onRepay }) {
  const link = useHistory();

  const linkToDetail = (params) => {
    link.push(`/use-history-detail/${params}`);
  };

  return (
    <>
      <tr className="txt-dark-gray">
        <th>
          <span className="txt-dark-gray">
            <span
              className="underline-black underline-hover-blue cursor"
              onClick={() => linkToDetail(`${history.id}/${history.is_reservation}`)}
            >
              {history.is_reservation === 1 ? "BR" : "BC"}{history.id}
            </span>
          </span>
        </th>
        <th>
          <span className="txt-dark-gray">
            {history.board_date ? history.board_date : "-"}{" "}
          </span>
        </th>
        <th>
          <span>{history.business_user_email}</span>
        </th>
        <th>
          <span>{history.business_user_name}</span>
        </th>
        <th>
          <span>
            {history.business_group_name ? history.business_group_name : "-"}
          </span>
        </th>
        <th>
          <span>{thousandFormat(history.total_fare)}원</span>
        </th>
        <th className="p-1">
          <p className="txt-red mb-0">
            {history.total_fare > 0
              ? thousandFormat(history.total_fare)
              : thousandFormat(history.fee)}
            원
          </p>
          <button
            className="btn-white-sm pl-2 pr-2"
            onClick={() => onRepay(history.id, history.is_reservation)}>
            재결제
          </button>
        </th>
      </tr>
    </>
  );
}

export default UnpaidHistoryItem;
